@if(src()){
  <iframe [src]="src() | sanitizerUrl:'url'" appIframeTrackerDirective></iframe>
}
